import { memo } from "react";
import { useNavigate, type To } from "react-router-dom";
import { Button, Icon, type ButtonProps } from "@mui/material";

type BackLinkProps = Omit<ButtonProps, "onClick"> & {
  navTo?: To | "";
  navReplaceTo?: To | "";
  className?: string;
  onClick?: ButtonProps["onClick"];
};

const BackLink = ({
  navTo = "",
  navReplaceTo = "",
  className = "",
  onClick,
  ...rest
}: BackLinkProps) => {
  const navigate = useNavigate();

  const handleClick =
    onClick ||
    (() =>
      navTo !== "" || navReplaceTo !== ""
        ? navReplaceTo !== ""
          ? navigate(navReplaceTo, { replace: true })
          : navigate(navTo)
        : navigate(-1));

  return (
    <div className={`${className}`}>
      <Button
        startIcon={<Icon fontSize="small">arrow_circle_left</Icon>}
        onClick={handleClick}
        style={{ color: "var(--palette-text-primary)" }}
        // color="black"
        size="small"
        {...rest}
      >
        Back
      </Button>
    </div>
  );
};

export default memo(BackLink);
